module.exports = __webpack_public_path__ + "img/合相.a3733235.svg";